<template>
  <li class="channel-list-container">
    <channelItem :item.sync="item" v-for="item in list" :key="item.id" @toDetail="toDetailPage"></channelItem>
  </li>
</template>
<script>
import channelItem from './channelItem'
export default {
  props: ["list"],
  components: {
    channelItem
  },
  methods: {
    toDetailPage(item) {
      this.$router.push({
        path: 'channelDetail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../common.less');
  .channel-list-container {
    width: 100vw;
    .display-flex;
    flex-direction: column;
  }
</style>
